import {
  ISideOffsets,
  LocationDirection,
  Side,
  TranslateFunction,
} from "../models/Common"
import { TailAttachment } from "../models/Sensor"
import { ISolution } from "../models/Solution"
import {
  BaseComponent,
  IComponentInfo,
  IComponentLabels,
  IComponentShape,
} from "./Base"
import { Sensor } from "./Sensor"

export class Sticker extends BaseComponent {
  public constructor(
    id: number,
    solution: ISolution,
    sensor: Sensor,
    t: TranslateFunction
  ) {
    const tail = solution.sensor.tail
    // decide how to draw the tail (width/length apply for vertical attachments):
    const tailRotated =
      tail.attachment === TailAttachment.Left ||
      tail.attachment === TailAttachment.Right
    const width = tailRotated ? tail.length : tail.width
    const height = tailRotated ? tail.width : tail.length
    let printedBorder = solution.printing?.frameThickness
    if (!printedBorder || solution.printing?.withPrinting === false)
      printedBorder = { l: 0, r: 0, t: 0, b: 0 } as ISideOffsets

    let scox = 0,
      scoy = 0 // central offsets

    switch (solution.sensor.tail.attachment) {
      case TailAttachment.Top:
        scoy =
          -0.5 * sensor.shape.height +
          (sensor.shape.centralOffsetY ?? 0) -
          0.5 * tail.length
        scox =
          ((printedBorder.l - printedBorder.r) / 2) *
            (printedBorder.l < printedBorder.r ? 1 : -1) +
          tail.centralOffset
        break
      case TailAttachment.Bottom:
        scoy =
          0.5 * sensor.shape.height +
          (sensor.shape.centralOffsetY ?? 0) +
          0.5 * tail.length
        scox =
          ((printedBorder.l - printedBorder.r) / 2) *
            (printedBorder.l < printedBorder.r ? 1 : -1) +
          tail.centralOffset
        break
      case TailAttachment.Left:
        scox =
          -0.5 * sensor.shape.width +
          (sensor.shape.centralOffsetX ?? 0) -
          0.5 * tail.length
        scoy =
          ((printedBorder.t - printedBorder.b) / 2) *
            (printedBorder.t < printedBorder.b ? 1 : -1) +
          tail.centralOffset
        break
      case TailAttachment.Right:
        scox =
          0.5 * sensor.shape.width +
          (sensor.shape.centralOffsetX ?? 0) +
          0.5 * tail.length
        scoy =
          ((printedBorder.t - printedBorder.b) / 2) *
            (printedBorder.t < printedBorder.b ? 1 : -1) +
          tail.centralOffset
        break
    }

    super(
      {
        id: id,
        color: "#00ccff",
        description: t("d_pet_part"), // with serial number and foil size stickers",
      } as IComponentInfo,
      {
        width: width,
        height: height,
        centralOffsetX: scox,
        centralOffsetY: scoy,
      } as IComponentShape,
      {
        dimensions: {
          sides: [Side.Top, Side.Right],
          diff: false,
        },
        description: false,
        id: {
          locationDirection: LocationDirection.Outward,
          fromSide: Side.Bottom,
          padding: 10,
        },
      } as IComponentLabels
    )
  }
}

export class StickerDimReference extends BaseComponent {
  public constructor(solution: ISolution, sticker: Sticker) {
    const tail = solution.sensor.tail
    const tailRotated =
      tail.attachment === TailAttachment.Left ||
      tail.attachment === TailAttachment.Right

    super(
      {
        id: -1,
        color: "#000",
        description: "",
      } as IComponentInfo,
      {
        width: 0.01,
        height: 0.01,
        centralOffsetX:
          sticker.shape.centralOffsetX -
          (!!tailRotated ? sticker.shape.width / 2 : 0),
        centralOffsetY:
          sticker.shape.centralOffsetY -
          (!tailRotated ? sticker.shape.height / 2 : 0),
      } as IComponentShape,
      {
        dimensions: {
          sides: !tailRotated ? [Side.Top] : [Side.Right],
          diff: true,
        },
        description: false,
      } as IComponentLabels
    )
  }
}
